<template>
  <div>
    <div class="quickview-search_wrapperSticky">
      <div class="field is-marginless">
        <div class="control has-icons-right quickview-search">
          <input
            ref="input"
            @input="startSearch"
            type="text"
            class="input is-large"
            v-model="input"
            placeholder="Rechercher dans la liste"
            :class="{'is-degrad-info has-text-white':input && input.length}">
          <span
            class="icon is-right is-size-3"
            :class="{'has-text-white':input && input.length}">
            <i class="fal fa-search"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="vadListeSelection">
      <ul>
        <div
          class="is-fullwidth has-text-centered is-padding"
          v-if="!displayableResults.length">
          <span class="icon is-size-4"><i class="fal fa-engine-warning"></i></span>
          <span class="is-margin-left-xsmall">La liste est vide</span>
        </div>
        <li
          v-else
          class="columns is-vcentered is-marginless is-border-bottom vadListeSelection-item"
          v-for="(e, i) in displayableResults"
          :key="i"
          @click="select(e)">
          <div class="column is-narrow">
            <avatar
              :item="e"
              :i="i"
              :force-initials="true"></avatar>
          </div>
          <div
            class="column is-paddingless-left is-paddingless-right is-size-5 is-clipped is-nowrap">
            <span v-if="e.corporation_name && e.nature === 'corporation' && e.first_name">{{ e.corporation_name }} - {{ e.last_name }} {{ e.first_name }}</span>
            <span v-else-if="e.last_name && e.first_name">{{ e.last_name }} {{ e.first_name }}</span>
            <span v-else-if="e.name">{{ e.name }}</span>
            <br v-if="e && e.profil || ('first_admin' in e && e.first_admin.name) ">
            <span
              class="has-text-grey is-size-6"
              v-if="e.profil">{{ e.profil | profilTypeLabel }}&nbsp;</span>
            <!-- <span
              class="has-text-black is-size-7"
              v-if="'user' in e && e.account.name">{{ e.account.name }}</span> -->
            <span
              class="has-text-black is-size-7"
              v-if="e.profil">{{ e.account.name }}</span>
            <span
              class="has-text-grey is-size-6"
              v-if="'first_admin' in e && (e.first_admin.name || e.first_admin.first_name)">Référent : </span>
            <span
              class="has-text-black is-size-7"
              v-if="'first_admin' in e && e.first_admin.first_name">{{ e.first_admin.first_name }} </span>
            <span
              class="has-text-black is-size-7"
              v-if="'first_admin' in e && e.first_admin.last_name">{{ e.first_admin.last_name }}</span>
            <span
              class="has-text-black is-size-7"
              v-if="'first_admin' in e && e.first_admin.name">{{ e.first_admin.name }}</span>
          </div>
          <div class="column is-narrow">
            <a
              v-if="entitiesPk.includes(e.pk)"
              class="button is-xsmall is-circle is-action is-success">
              <span class="icon is-small"><i class="fas fa-check"></i></span>
            </a>
            <a
              v-else
              class="button is-xsmall is-circle is-action is-light">
              <span class="icon is-small"><i class="fal fa-plus"></i></span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { DefaultValues, Quickview } from '@/mixins'

export default {
  name: 'EntitySelection',
  mixins: [
    Quickview,
    DefaultValues
  ],
  props: {
    paramsQuickview: Object,
    facets: Object
  },
  data () {
    return {
      searchKeys: ['USER'],
      activeUsers: []
    }
  },
  computed: {
    canSubmit () {
      return this.entities.length > 0
    },
    displayableResults () {
      return this.results
        .filter(x => !this.activeUsers.includes(x.first_admin ? x.first_admin.pk : x.pk))
        // fiches sans aucun nom affichable (ex : fiches conjoint vides) : rien à montrer ni sélectionner
        .filter(x => x.first_name || x.last_name || x.name || x.corporation_name)
    }
  },
  created () {
    if (this.paramsQuickview.searchKeys && this.paramsQuickview.searchKeys === 'ACCOUNT') {
      this.activeUsers = this.facets.ACCOUNT.map(x => x[0].split('pk:-')[1])
    } else if (this.paramsQuickview.searchKeys && this.paramsQuickview.searchKeys === 'USER') {
      this.activeUsers = this.facets.USER.map(x => x[0].split('pk:-')[1])
    }
    this.input = ''
    if (this.paramsQuickview && this.paramsQuickview.searchKeys) {
      if (Array.isArray(this.paramsQuickview.searchKeys)) this.searchKeys = this.paramsQuickview.searchKeys
      else this.searchKeys = [this.paramsQuickview.searchKeys]
    }
    if ('mode' in this.paramsQuickview && this.paramsQuickview.mode) {
      this.quickViewMode = this.paramsQuickview.mode
    }
    // this.getUsers()
  },
  mounted: function () {
    this.startSearch()
    this.$refs.input.focus()
  },
  methods: {
    submitQuickview () {
      this.$emit('submitQuickview', { entities: this.entities })
    },
    select (r) {
      if (this.entitiesPk.includes(r.pk)) {
        this.unselectEntity(r)
      } else {
        this.selectEntity(r)
      }
    }
  }
}
</script>
